import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceWithStateReset } from 'store/createSliceWithStateReset';
import { RootState } from 'store/store';

type AttachmentOpenDialog = {
  type: 'open';
  messageId?: number;
  link?: string;
};

type AttachmentPopoverMenu = {
  type: 'menu';
  selectedImage: HTMLElement;
  attachmentId: number;
};

type AttachmentRemoveConfirmDialog = {
  type: 'remove-confirm';
  attachmentId: number;
};

type ConfirmationDialog =
  | AttachmentOpenDialog
  | AttachmentPopoverMenu
  | AttachmentRemoveConfirmDialog;

interface InitialState {
  unreadMessagesCount: number;
  confirmationDialog: ConfirmationDialog | null;
  focusedMessageId: number | null;
}

const initialState: InitialState = {
  unreadMessagesCount: 0,
  confirmationDialog: null,
  focusedMessageId: null,
};

const chatSlice = createSliceWithStateReset({
  name: 'chat',
  initialState,
  reducers: {
    setUnreadMessagesCount: (state, action: PayloadAction<{ unreadMessagesCount: number }>) => ({
      ...state,
      unreadMessagesCount: action.payload.unreadMessagesCount,
    }),
    showDialog: (state, action: PayloadAction<ConfirmationDialog>) => ({
      ...state,
      confirmationDialog: action.payload,
    }),
    hideDialog: (state) => ({
      ...state,
      confirmationDialog: null,
    }),
    setFocusedMessageId: (state, action: PayloadAction<{ messageId: number | null }>) => ({
      ...state,
      focusedMessageId: action.payload.messageId,
    }),
  },
});

export const { setUnreadMessagesCount, showDialog, hideDialog, setFocusedMessageId } =
  chatSlice.actions;
export const { reducer: chatReducer } = chatSlice;

export const selectUnreadMessagesCount = (state: RootState) => state.chat.unreadMessagesCount;
export const selectDialog = (state: RootState) => state.chat.confirmationDialog;
export const selectFocusedMessageId = (state: RootState) => state.chat.focusedMessageId;
